export enum ApplicationType {
    SHORT = 'application.applications-overview.one-week',
    LONG = 'application.applications-overview.two-weeks'
}
